import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Frame from '../layout/Frame';
import SiteSelection from '../components/Onboarding/SiteSelection';
import Checking from '../components/Onboarding/Checking';
import Done from '../components/Onboarding/Done';
import { fetchSuggestedWebsites } from '../requests/requests';
import { AppRoute } from '../types/enums';
import { SuggestedWebsite } from '../types/types';

const Onboarding = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(STEPS[0]);
  const [toCheck, setToCheck] = useState<SuggestedWebsite[]>([]);

  const next = useCallback(() => {
    setStep((old) => {
      const currentIndex = STEPS.indexOf(old);

      return STEPS[currentIndex + 1];
    });
  }, []);

  useEffect(() => {
    fetchSuggestedWebsites()
      .then((res) => {
        setToCheck(res.data.map((it) => ({ ...it, active: true })));
      })
      .catch(() => {
        navigate(AppRoute.WEBSITES);
      });
  }, []);

  return (
    <Frame>
      {step === Step.START && (
        <SiteSelection next={next} setToCheck={setToCheck} toCheck={toCheck} />
      )}
      {step === Step.CHECKING && <Checking next={next} toCheck={toCheck} />}
      {step === Step.DONE && <Done />}
    </Frame>
  );
};

enum Step {
  START,
  CHECKING,
  DONE
}

const STEPS = [Step.START, Step.CHECKING, Step.DONE];

export default Onboarding;
